import PropTypes from 'prop-types';
import React, { useState } from 'react';

import ProgressionBody from './ProgressionBody';

const propTypes = {
  data: PropTypes.array,
  progressionType: PropTypes.string,
};

const ProgressionResults = ({ data, progressionType }) => {
  const [shownCard, setShownCard] = useState(0)

  if (!data) {
    return <div className='font-semibold text-center'>Please select a site in configure section.</div>;
  }

  if (!data.length) {
    return <div className='font-semibold text-center'>No results to show.</div>;
  }

  return <div className='flex flex-col gap-4'>
    {data.map((item, idx) => <ProgressionBody
      key={item.id}
      item={item}
      progressionType={progressionType}
      isShow={shownCard === idx}
      onShow={() => setShownCard(idx)}
    />)}
  </div>
}

ProgressionResults.propTypes = propTypes;

export default ProgressionResults;
